import { render, staticRenderFns } from "./simple-order-table.vue?vue&type=template&id=0bcf73a4&"
import script from "./simple-order-table.vue?vue&type=script&lang=js&"
export * from "./simple-order-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports